import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

export class ChatRepository {
    // 메시지 전송
    static onPostSendMessage = (meetingId: string, params: any) => {
        return onRequest({
            url: `${getApiUrl('chatMessages')}/${meetingId}/messages`,
            method: RequestMethod.POST,
            params
        })
    }

    // 메시지 목록 조회
    static onGetChatMessages = (meetingId: string, query?: { cursor?: string; pageSize?: number }) => {
        return onRequest({
            url: `${getApiUrl('chatMessages')}/${meetingId}/messages`,
            method: RequestMethod.GET,
            query
        })
    }

    // 메시지 읽음 처리
    static onPostMarkAsRead = (params: any) => {
        return onRequest({
            url: getApiUrl('chatRead') + '/messages/read',
            method: RequestMethod.POST,
            params
        })
    }

    // 내가 속한 채팅방 목록 (인앱 알림 배너용)
    static onGetChatRoomList = () => {
        return onRequest({
            url: getApiUrl('chatRoomList'),
            method: RequestMethod.GET,
        })
    }
}
